import { useQuery } from '@tanstack/react-query'
import type { EntityType } from '../../types'
import { workflowApiFor } from '../api'
import { queryKeys } from '../queryKeys'

type Args = {
  entityType?: EntityType
  entityId: string
}

export const useGetWorkflowByContext = ({
  entityType = 'moment',
  entityId,
}: Args) =>
  useQuery({
    queryKey: queryKeys.workflowByEntity(entityType, entityId, 'workflow'),
    queryFn: () => workflowApiFor(entityType).readWorkflow({ entityId }),
    useErrorBoundary: true,
  })

export const useGetWorkflowStatus = ({
  entityType = 'moment',
  entityId,
}: Args) =>
  useQuery({
    queryKey: queryKeys.workflowByEntity(entityType, entityId, 'status'),
    queryFn: () => workflowApiFor(entityType).readWorkflowStatus({ entityId }),
    useErrorBoundary: true,
  })
